import Joi from 'joi';

export const AnswerQuizSchema = Joi.object({
  options: Joi.array().items(
    Joi.number().required().messages({ 'any.required': 'Required!' }),
  ),
});
